// @flow
import React from 'react';
import type { Node } from 'react';
import { SortableElement, SortableHandle } from "react-sortable-hoc";
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemIcon from "@material-ui/core/ListItemIcon";
import IconButton from '@material-ui/core/IconButton';
import DragHandleIcon from "@material-ui/icons/DragHandle";
import DeleteIcon from '@material-ui/icons/Delete';

const DragHandle = SortableHandle(() => (
    <ListItemIcon>
        <DragHandleIcon />
    </ListItemIcon>
));

const SortableItem = SortableElement(ListItem);

type Props = $ReadOnly<{
    index: number,
    value: string | number,
    canRemove: boolean,
    editable?: boolean,
    sortable?: boolean,
    ItemComponent: Node,
    inputComponent?: Node,
    parseLabel?: (value: any) => Node,
    append?: Node,

    onChange: (value: any, index: number) => void,
    onDelete: (index: number) => void
}>;

function ArrayItem({ index, value, canRemove, editable, sortable, ItemComponent, inputComponent, parseLabel, append, onChange, onDelete }: Props) {
    const handleChange = (e) => onChange(e.target.value, index);
    const handleDelete = () => onDelete(index);

    return (
        <SortableItem index={index} ContainerComponent="div" disabled={!sortable}>
            <ItemComponent
                value={value}
                editable={editable}
                parseLabel={parseLabel}
                inputComponent={inputComponent}
                append={append}
                onChange={handleChange}
            />
            <ListItemSecondaryAction>
                {sortable && <DragHandle />}
                <IconButton edge="end" aria-label="delete" disabled={!canRemove} onClick={handleDelete}>
                    <DeleteIcon />
                </IconButton>
            </ListItemSecondaryAction>
        </SortableItem>
    );
}

export default ArrayItem;